import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const countriesReducer = (state = initialState.countries, action) => {
  switch (action.type) {
    case types.GET_COUNTRIES_SUCCESS: {
      let result =
        action.payload &&
        action.payload.map(c => {
          let country = {};
          country.key = c.countryCode;
          country.value = c.countryCode;
          country.label = c.countryName;
          return country;
        });
      return result;
    }
    case types.GET_COUNTRIES_FAILED:
      return initialState.countries;

    default:
      return state;
  }
};

export const selectedCountryReducer = (
  state = initialState.selectedCountry,
  action
) => {
  switch (action.type) {
    case types.SET_COUNTRY:
      return action.payload;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/countriesReducer.js